import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import {refreshAccessToken, isAccessTokenExpired} from './auth0/access-token';
import constants from '../constants';

const httpEndpoint = `${constants.CLOUD_NITRO_API_ENDPOINT}`;
const cache = new InMemoryCache();

export default async function apolloClient() {
  if (isAccessTokenExpired()) {
    throw new Error('Session has expired');
  }

  const headers = {
    Authorization: `Bearer ${await refreshAccessToken({ ignoreCache: true })}`,
    'x-legacy-auth': localStorage.getItem('auth/token')
  };

  return new ApolloClient({
    link: new HttpLink({ uri: httpEndpoint, headers }),
    cache
  });
}



// WEBPACK FOOTER //
// ./src/utils/apollo-client.js